{
  "Name": "Hannover Messe",
  "ImageFile": "HMI-Logo.jpg",
  "Path": "/machines/hmi",
  "Position": {
    "lat": 52.37052,
    "lng": 9.73322
  },
  "Tag": "hmi",
  "From": "12.04.2021",
  "To": "16.04.2021",
  "Halls": ["1", "4", "5", "6"]
}
